import { auth } from '@/constants';
import IdTokenVerifier from 'idtoken-verifier';
import { TokenResponse } from '@/types/openid';

const LEEWAY_SECONDS = 300;
const verifier = new IdTokenVerifier({
  issuer: auth.ISSUER,
  audience: auth.CLIENT_ID,
  jwksURI: auth.Url.jwksUri,
  leeway: LEEWAY_SECONDS,
});

export const verifyIdToken = (idToken: string, nonce: string) => {
  return new Promise((resolve, reject) => {
    verifier.verify(idToken, nonce, (error, payload) => {
      // NOTE: トークン検証失敗時に返却されるエラー内容について
      // ref) https://github.com/auth0/idtoken-verifier/blob/27db28ca9d95d9ecf5b4b4ba3fc56a15169cb2b2/src/helpers/error.js#L7
      if (error) reject(error);

      resolve(payload);
    });
  });
};

export const decodeIdToken = (idToken: TokenResponse['idToken']) =>
  verifier.decode(idToken);
